import type { Priority, TaskId } from "../../../../shared/types";
import { ContextMenu } from "../../../../ui/atoms/ContextMenu";
import { ConfirmDialog } from "../../../../ui/atoms/ConfirmDialog";

interface TaskItemMenusProps {
  readonly taskId: TaskId;
  readonly taskTitle: string;
  readonly taskPriority: Priority;
  readonly contextMenu: DOMRect | null;
  readonly confirmDelete: boolean;
  readonly onContextMenuClose: () => void;
  readonly onStartEdit: () => void;
  readonly onTogglePriority: (priority: Priority) => void;
  readonly onConfirmDelete: () => void;
  readonly onCancelDelete: () => void;
}

export function TaskItemMenus({
  taskTitle,
  taskPriority,
  contextMenu,
  confirmDelete,
  onContextMenuClose,
  onStartEdit,
  onTogglePriority,
  onConfirmDelete,
  onCancelDelete,
}: TaskItemMenusProps) {
  return (
    <>
      {contextMenu && (
        <ContextMenu
          items={[
            { label: "Éditer", onClick: onStartEdit },
            {
              label: `Priorité: ${taskPriority === "urgent" ? "Normal" : "Urgent"}`,
              onClick: () =>
                onTogglePriority(
                  (taskPriority === "urgent" ? "normal" : "urgent") as Priority,
                ),
            },
            {
              label: "Supprimer",
              onClick: onConfirmDelete,
              danger: true,
            },
          ]}
          anchorRect={contextMenu}
          onClose={onContextMenuClose}
        />
      )}

      <ConfirmDialog
        open={confirmDelete}
        title="Supprimer la tâche"
        message={`Supprimer « ${taskTitle} » ? Cette action est irréversible.`}
        confirmLabel="Supprimer"
        variant="danger"
        onConfirm={onConfirmDelete}
        onCancel={onCancelDelete}
      />
    </>
  );
}
